<template>
    <div class="header-wrapper">
        <header class="header-content">
            <div class="left" @click="goBack">
                <img :src="require(`@/assets/images/icons/back.png`)" alt="" height="24px" />
            </div>
            <div class="center h_logo" @click="goHome">
                <img :src="require('@/assets/images/front_bi.png')" alt="" height="31px" />
            </div>
        </header>
    </div>
</template>
<script>
export default {
    name: 'ApplyHeader',
    props: {
        leftButtonHandler: {
            type: Function,
        },
        pageName: {
            type: String,
            required: false,
        },
        goHomeHandler: {
            type: Function,
            required: false,
        },
    },
    computed: {
        me() {
            return this.$store.getters.me
        },
    },
    methods: {
        goBack() {
            if (this.leftButtonHandler) {
                this.leftButtonHandler()
            }
        },
        goHome() {
            // part1 입력이 끝나지않은 유저는 본 화면에서 빠져나갈 수 없어야한다.
            // 설사 빠져나가더라도 apply/form 화면으로 redirect 되어야한다.
            console.log('goHome')
            if (this.pageName === 'intro' && this.goHomeHandler) {
                return this.goHomeHandler()
            }
            // if (this.pageName === 'intro' && !this.me) {
            //     return this.$router.push('/')
            // }

            if (this.me.profile.is_pass !== 'before_judgment') {
                console.log('passed part1')
                this.$router.push('/chats')
            } else if (['judgment_required', 'pass'].indexOf(this.me.profile.is_pass) !== -1) {
                // this.$router.push('/front')
                this.$modal.basic({
                    title: '프로필 심사 필요',
                    body: '프로필 정보를 모두 입력하고, 심사를 요청해주세요.',
                    buttons: [
                        {
                            label: 'CONFIRM',
                            class: 'btn-primary',
                        },
                    ],
                })
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.header-wrapper {
    width: 100%;
    height: 56px;
    background-color: white;
    position: fixed;
    // top: 0;
    top: calc(var(--android-top-ui, 0px));
    z-index: 2;

    .header-content {
        width: inherit;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 12px;
    }

    .left {
        width: 24px;
        height: 24px;
        position: absolute;
        left: 12px;
        top: 16px;
    }
}
</style>
